import { expandProperty } from "inline-style-expand-shorthand";

export const withoutBorderRadiusStyles = expandProperty("borderRadius", "0");

export const withoutBorderStyles = expandProperty("border", "none");
